/*
 * @Description:
 * @Author: yingbin
 * @Date: 2019-08-22 15:22:33
 * @LastEditTime: 2019-09-25 12:35:12
 * @LastEditors: yingbin
 */
import Vue from "vue";
import Router from "vue-router";
import utils from '@/utils/utils';

const layout_main = resolve => {
	import("../layout/layout_main.vue").then(module => {
		resolve(module);
	});
};
const index = resolve => {
	import("../views/index.vue").then(module => {
		resolve(module);
	});
};
const login = resolve => {
	import("../views/login.vue").then(module => {
		resolve(module);
	});
};
const register = resolve => {
	import("../views/register.vue").then(module => {
		resolve(module);
	});
};
const getPswd = resolve => {
	import("../views/getPswd.vue").then(module => {
		resolve(module);
	});
};
// 首页
const account = resolve => {
	import("../views/account.vue").then(module => {
		resolve(module);
	});
};
const company = resolve => {
	import("../components/account/company.vue").then(module => {
		resolve(module);
	});
};
const userInfo = resolve => {
	import("../components/account/userInfo.vue").then(module => {
		resolve(module);
	});
};
const updatePswd = resolve => {
	import("../components/account/updatePswd.vue").then(module => {
		resolve(module);
	});
};
const examineResult = resolve => {
	import("../components/account/examineResult.vue").then(module => {
		resolve(module);
	});
};
// 控制台
const control = resolve => {
	import("../views/control.vue").then(module => {
		resolve(module);
	});
};
const applicationManagement = resolve => {
	import("../components/control/applicationManagement.vue").then(module => {
		resolve(module);
	});
};
const logMonitoring = resolve => {
	import("../components/control/logMonitoring.vue").then(module => {
		resolve(module);
	});
};
// 帮助文档
const help = resolve => {
	import("../views/help.vue").then(module => {
		resolve(module);
	});
};
const baseProblems = resolve => {
	import("../components/help/baseProblems.vue").then(module => {
		resolve(module);
	});
};
const api = resolve => {
	import("../views/api.vue").then(module => {
		resolve(module);
	});
};
const apiDoc = resolve => {
	import("../components/apis/apiDoc.vue").then(module => {
		resolve(module);
	});
};
const horn= resolve => {
	import("../views/horn.vue").then(module => {
		resolve(module);
	});
};
const Solution = resolve => {
	import("../views/Solution.vue").then(module => {
		resolve(module);
	});
};
const openDoc = resolve => {
	import("../views/opendoc.vue").then(module => {
		resolve(module);
	});
};
const error = resolve => {
	import("../views/404.vue").then(module => {
		resolve(module);
	});
};
Vue.use(Router);
console.log(utils.getEnv());
export default new Router({
	mode: utils.getEnv() === 'pro' ? 'history' : 'hash',
	routes: [{
		path: "/",
		component: layout_main,
		redirect: "/index",
		children: [{
			path: "/index",
			name: index,
			component: index,
			meta: {
				title: "韵达开放平台",
				rule: [1]
			}
		}]
	}, {
		path: "/account",
		name: "account",
		component: account,
		redirect: "/account/userInfo",
		children: [{
			path: "/account/company",
			name: "company",
			component: company,
			meta: {
				title: "韵达开放平台",
				rule: [1]
			}
		}, {
			path: "/account/userInfo",
			name: "userInfo",
			component: () => import('@/components/account/user'),
			meta: {
				title: "韵达开放平台",
				rule: [1]
			}
		}, {
			path: "/account/updatePswd",
			name: "updatePswd",
			component: updatePswd,
			meta: {
				title: "韵达开放平台",
				rule: [1]
			}
		}, {
			path: "/account/examineResult",
			name: "examineResult",
			component: examineResult,
			meta: {
				title: "韵达开放平台",
				rule: [1]
			}
		}]
	}, {
		path: "/api",
		name: "api",
		component: api,
		redirect: "api/apiDoc",
		children: [{
			path: "/api/apiDoc",
			name: "apiDoc",
			component: apiDoc,
			meta: {
				title: "韵达开放平台",
				rule: [1]
			}
		}]
	}, {
		path: "/Solution",
		component: Solution,
		name: "Solution",
		meta: {
			title: "韵达开放平台",
			rule: [1]
		}
	},{	
		path: "/opendoc",
		component: openDoc,
		name: "opendoc",
		meta: {
			title: "韵达开放平台",
			rule: [1]
		}
	},{
		path: "/login",
		component: login,
		name: "login",
		meta: {
			title: "韵达开放平台",
			rule: [1]
		}
	}, {
		path: "/register",
		component: register,
		name: "register",
		meta: {
			title: "韵达开放平台",
			rule: [1]
		}
	}, {
		path: "/getPswd",
		component: getPswd,
		name: "getPswd",
		meta: {
			title: "韵达开放平台",
			rule: [1]
		}
	},{
		path: "/horn",
		component: horn,
		name: "horn",
		meta: {
			title: "韵达开放平台",
			rule: [1]
		}
	},{
		path: "/control",
		name: "control",
		component: control,
		redirect: "/control/applicationManagement",
		children: [{
			path: "/control/applicationManagement",
			name: "applicationManagement",
			redirect: '/control/apis/list',
			component: applicationManagement,
			children: [
				{
					path: "/control/applicationManagement/list",
					name: "applicationManagement",
					component: () => import('@/components/control/application/list'),
					meta: {
						title: "韵达开放平台",
						rule: [1]
					}
				}, {
					path: "/control/applicationManagement/detail/:id",
					name: "applicationManagement",
					component: () => import('@/components/control/application/details'),
					meta: {
						title: "韵达开放平台",
						rule: [1]
					}
				}, {
					path: "/control/applicationManagement/edit/:id",
					name: "applicationManagement",
					component: () => import('@/components/control/application/edit'),
					meta: {
						title: "韵达开放平台",
						rule: [1]
					}
				}, {
					path: "/control/apis/list",
					name: "applicationManagement",
					component: () => import('@/components/control/apis/list'),
					meta: {
						title: "韵达开放平台",
						rule: [1]
					}
				}
			],
			meta: {
				title: "韵达开放平台",
				rule: [1]
			}
		}, {
			path: "/control/logMonitoring",
			name: "logMonitoring",
			component: logMonitoring,
			meta: {
				title: "韵达开放平台",
				rule: [1]
			}
		}, {
			path: "/control/newApplication",
			name: "newApplication",
			component: () => import('@/components/control/application/edit'),
			meta: {
				title: "韵达开放平台",
				rule: [1]
			}
		}, {
			path: "/control/testApi",
			name: "testApi",
			component: () => import('@/components/control/testApi'),
			meta: {
				title: "韵达开放平台",
				rule: [1]
			}
		},{
			path: "/control/pbjoint",
			name: "pbjoint",
			component: () => import('@/components/control/pbJoint/pbjoint.vue'),
			meta: {
				title: "韵达开放平台",
				rule: [1]
			}
		},{
			path: "/control/sign",
			name: "checkSign",
			component: () => import('@/components/control/sign/checkSign.vue'),
			meta: {
				title: "韵达开放平台",
				rule: [1]
			}
		}]
	}, {
		path: "/help",
		name: "help",
		component: help,
		redirect: "/help/baseProblems",
		children: [
			{
				path: "/help/baseProblems",
				name: "baseProblems",
				component: baseProblems,
				meta: {
					title: "韵达开放平台",
					rule: [1]
				}
			}, {
				path: "/help/developer",
				name: "developer",
				component: () => import('@/components/help/developer'),
				meta: {
					title: "韵达开放平台",
					rule: [1]
				}
			}, {
				path: "/help/search",
				name: "search",
				component: () => import('@/components/help/search'),
				meta: {
					title: "韵达开放平台",
					rule: [1]
				}
			}, {
				path: "/help/applyDevHelp",
				name: "applyDevHelp",
				component: () => import('@/components/help/applyDevHelp'),
				meta: {
					title: "韵达开放平台",
					rule: [1]
				}
			},
		]
	},{
		path: "/404",
		component: error,
		name: "404",
		meta: {
			title: "韵达开放平台",
			rule: [1]
		}
	},
	/** 页面路径错误，重定向至首页 */
	{ path: "*", name: "error", redirect: '/404', meta: {} }
	]
});

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}